import ReportFilterDropdown from "@/reports/components/ReportFilterDropdown";
import { ClassroomStudent } from "@/types/models/Classroom.interface";

export interface StudentFilterProps {
  studentList?: ClassroomStudent[] | undefined;
}

const StudentFilter = ({ studentList }: StudentFilterProps) => {
  const studentOptions = studentList?.map((student: ClassroomStudent) => {
    return {
      value: student.unique_id.toString() || "",
      label: `${student.user.first_name} ${student.user.last_name}` || "",
    };
  });

  const defaultOption = { value: "", label: "All Students" };
  const menuOptions = studentOptions ? [...studentOptions] : [defaultOption];

  return (
    <ReportFilterDropdown
      menuOptions={menuOptions}
      defaultOption={defaultOption}
      label="Student"
      urlSearchParam="student"
      eventTrackingDescription="Teacher Reporting - student filter"
    />
  );
};

export default StudentFilter;
